import React, { useState } from "react";

import clsx from 'clsx';
import PropTypes from "prop-types";

import {
  Grid,
  Typography,
  StepLabel,
  Step,
  Stepper,
  Paper,
  withStyles,
  StepConnector,
  makeStyles,
} from "@material-ui/core";
import { ValidatorForm } from "react-material-ui-form-validator";

import { ButtonGeneric } from "../atoms/Buttons";
import { useStylesAuth } from "../../../styles/auth/style";
import { Fragment } from "react";


const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    '& $line': {
      backgroundImage:
        'linear-gradient(151deg, rgba(171,150,241,1) 0%, rgba(120,12,191,1) 100%)',
    },
  },
  completed: {
    '& $line': {
      backgroundImage:
        'linear-gradient(151deg, rgba(171,150,241,1) 0%, rgba(120,12,191,1) 100%)',
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1,
  },
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  active: {
    backgroundImage:
      'linear-gradient(151deg, rgba(171,150,241,1) 0%, rgba(120,12,191,1) 100%)',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  },
  completed: {
    backgroundImage:
      'linear-gradient(151deg, rgba(171,150,241,1) 0%, rgba(120,12,191,1) 100%)',
  },
});

export const GenericStepperForm = ({ steps = [], stepIcons, handleSubmit, title, onClose, Banner }) => {
  const classes = useStylesAuth();

  const initStep = steps.map(({initStep}, index) => ({initStep, index})).find(x => x.initStep);
  const [activeStep, setActiveStep] = useState(initStep ? initStep.index : 0);

  const isFirstStep = activeStep === 0;
  const isLastStep = activeStep === steps.length - 1;

  const activeStepData = steps[activeStep];
  const { stepBanner } = activeStepData;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    const setActive = () => setActiveStep((prevActiveStep) => prevActiveStep - 1);
    if (!!activeStepData?.handleClickBack) activeStepData?.handleClickBack(setActive);
    else setActive();
  };

  const onSubmit = (e) => {
    if (isLastStep) {
      e.preventDefault();
      handleSubmit(() => { setActiveStep(0) });
    } else {
      if (!!activeStepData?.handleClickNext) activeStepData?.handleClickNext(handleNext);
      else handleNext();
    }
  };

  const ColorlibStepIcon = (props) => {
    const classes = useColorlibStepIconStyles();
    const { active, completed, icon } = props;

    return (
      <div
        className={clsx(classes.root, {
          [classes.active]: active,
          [classes.completed]: completed,
        })}
      >
        {stepIcons[String(icon)]}
      </div>
    );
  };

  ColorlibStepIcon.propTypes = {
    active: PropTypes.bool,
    completed: PropTypes.bool,
    icon: PropTypes.node,
  };

  return (
    
      <Grid container justify="center" alignItems="center" style={{with: "100%"}}>

        <Grid
          item
          xs={12}
          md={11}
          component={Paper}
          elevation={2}
          style={{ display: "center", justifyContent: "center", alignItems: "center", padding: 0 }}
        >
          {title && (
            <div style={{ width: "100%", textAlign: "center", padding: "0.5em" }} className={classes.color}>
              <Typography variant="button" style={{ fontSize: "1.2em", color: "#fff" }}>{title}</Typography>
            </div>
          )}
          <Stepper activeStep={activeStep} alternativeLabel connector={<ColorlibConnector />}>
            {steps.map(({ stepLabel }, index) => (
              <Step key={index}>
                <StepLabel
                  StepIconComponent={ColorlibStepIcon}
                  active={activeStep === index}
                  completed={activeStep > index}
                >
                  {stepLabel}
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Grid>

        {stepBanner && Banner && (
          <Grid item xs={12} md={11} elevation={3} style={{marginTop: "2em"}}>
            {Banner}
          </Grid>
        )}

        <Grid item xs={12} md={11} elevation={3} style={{ marginTop: stepBanner && Banner ? "0.5em" : "2em" }}>
          <ValidatorForm onSubmit={onSubmit}>
            <Grid container component={Paper} style={{padding: "1em"}}>
              <Grid item xs={12}>
                {steps.map(({ Component }, index) => (
                  <Fragment key={index}>
                    {activeStep === index && (
                      Component
                    )}
                  </Fragment>
                ))}
              </Grid>
              <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", gap: '0.5em', marginTop: '1em' }}>
                <ButtonGeneric
                  type="button"
                  color="secondary"
                  onClick={isFirstStep ? () => onClose() : handleBack}
                  disabled={(isFirstStep) || activeStepData?.disabledBack}
                  text={(isFirstStep) ? "Cerrar" : (activeStepData?.buttonLabelBack || "Volver")}
                />
                <ButtonGeneric
                  type="submit"
                  color="primary"
                  text={isLastStep ? activeStepData?.buttonLabelFinish || "Guardar" : activeStepData?.buttonLabelNext || "Siguiente"}
                  disabled={activeStepData?.disabledNext}
                />
              </Grid>
            </Grid>
          </ValidatorForm>
        </Grid>

      </Grid>
  );
};
